/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_GlowInputs */

const fr_fancy_vast_otter_glow = /** @type {(inputs: Fancy_Vast_Otter_GlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement sera annulé à la fin de la période en cours`)
};

/**

* @param {Fancy_Vast_Otter_GlowInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_glow = /** @type {((inputs?: Fancy_Vast_Otter_GlowInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_GlowInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_glow(inputs)
});